import request from "@/utils/request";

// 抽检入库
export function getBanners(data) {
  return request({
    url: "/internet/home/carousel",
    method: "post",
    data,
  });
}

// 获取头部菜单
export function getMenus(data) {
  return request({
    url: "/internet/menus",
    method: "get",
    data,
  });
}

// 获取栏目详情内容
export function getDetailInfo({ t, d }) {
  return request({
    url: `/internet/detail/${t}/${d}`,
    method: "get",
  });
}
// 获取文章详情
export function getArticleInfo(id) {
  return request({
    url: `/internet/detail/${id}`,
    method: "get",
  });
}

// 获取通知中心列表
export function getHomeList(data) {
  return request({
    url: `/internet/home/list`,
    method: "post",
    data,
  });
}

// 获取列表内容
export function getListContent(data) {
  return request({
    url: `/internet/list`,
    method: "post",
    data,
  });
}
